import { cleanStringFromNonDigits } from '@hrlogics/helper-utils';

import { SSN_MASK } from '@clearverify/constants';
import { Nullable } from '@clearverify/types';
import { formatWithMask } from '@clearverify/utils';

export const formatSsnNumber = (ssnNumber: Nullable<string>) => {
  if (!ssnNumber) return null;
  return formatWithMask(ssnNumber, SSN_MASK);
};

export const formatMaskedSsnNumber = (last4OfSsnNumber: string) => {
  if (!last4OfSsnNumber) return null;
  return formatWithMask(`*****${last4OfSsnNumber}`, SSN_MASK);
};

export const maskSsnNumber = (ssnNumber: Nullable<string>, replaceValue?: string) => {
  if (!ssnNumber) return null;
  return ssnNumber.replace(/^\d{1,5}/, x => x.replace(/./g, replaceValue || '*'));
};

export const processSsnMask = (ssnNumber: string) => {
  const patternSsn = /^(\d{3})-(\d{2})-(\d{4})$/;

  if (patternSsn.test(ssnNumber)) {
    return cleanStringFromNonDigits(ssnNumber);
  }

  return ssnNumber;
};
